import { storyblokEditable } from "@storyblok/react";
import LargeTextCard from "./LargeTextCard";

const LargeTextCardRow = ({ blok }) => {
  return (
    <section
      {...storyblokEditable(blok)}
      className="w-full bg-[#02053D] py-16 text-white"
    >
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-8">
          {blok.heading || "Asset Tracking Resources"}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          {blok.cards?.map(card => (
            <LargeTextCard blok={card} key={card._uid} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LargeTextCardRow;
